<template>
  <v-card
    class="w-full max-w-md p-6 rounded-[1.5rem] shadow-xl bg-radiant text-white self-center"
    style="border-radius: 1.5rem; overflow: hidden"
  >
    <div v-if="login">
      <v-tabs v-model="tab" grow>
        <v-tab value="register">Inscription</v-tab>
        <v-tab value="login">Connexion</v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <!-- Connexion -->
        <!-- Inscription -->
        <v-window-item value="register">
          <form @submit.prevent="handleRegister" class="mt-4">
            <v-text-field
              label="Pseudo (15 caractères max)"
              v-model="registerForm.name"
              prepend-inner-icon="mdi-account"
              required
              :counter="15"
              maxlength="15"
              :rules="[v => !!v || 'Requis', !infoUsername || 'Ce pseudo est déjà utilisé']"
            />
            <v-text-field
              label="Email"
              v-model="registerForm.email"
              type="email"
              prepend-inner-icon="mdi-email"
              required
              :rules="[v => /.+@.+\..+/.test(v) || 'Email invalide', !infoEmail || 'Cet email est déjà utilisé']"
            />
            <v-text-field
              label="Mot de passe"
              v-model="registerForm.password"
              :type="montrerMotDePasse ? 'text' : 'password'"
              :append-inner-icon="montrerMotDePasse ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="montrerMotDePasse = !montrerMotDePasse"
              prepend-inner-icon="mdi-lock"
              required
              :rules="[v => !!v || 'Requis', v => (v && v.length >= 6) || 'Minimum 6 caractères requis']"
            />
            <v-btn type="submit" class="bg-linear rounded-lg" style="box-shadow: none" block>S'inscrire</v-btn>
          </form>
        </v-window-item>
        <v-window-item value="login">
          <form @submit.prevent="handleLogin" class="mt-4">
            <v-text-field label="Pseudo ou Email" v-model="loginForm.email" prepend-inner-icon="mdi-account" required />
            <v-text-field
              label="Mot de passe"
              v-model="loginForm.password"
              :type="montrerMotDePasse2 ? 'text' : 'password'"
              :append-inner-icon="montrerMotDePasse2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="montrerMotDePasse2 = !montrerMotDePasse2"
              prepend-inner-icon="mdi-lock"
              required
              :rules="[
                v => !!v || 'Requis',
                !errorMDP || 'Pseudo ou mot de passe incorrect',
                !waitTime || `Trop de tentatives. Réessayes dans ${waitTime}s`,
              ]"
            />
            <span class="flex justify-end mb-1 mt-[-5px] cursor-pointer" @click="resetPassword()"
              >Mot de passe oublié ?</span
            >

            <v-btn type="submit" class="bg-linear rounded-lg" style="box-shadow: none" block>Se connecter</v-btn>
          </form>
        </v-window-item>
      </v-window>
      <div class="mt-2"></div>
      <v-divider><span class="text-[#c7cef8]">ou</span></v-divider>
      <div class="flex flex-col items-center min-h-[55px] justify-center relative">
        <button
          class="w-full flex items-center justify-center gap-2 py-2 px-4 rounded-lg hover:bg-gray-100 transition absolute mx-6 font-semibold bg-white"
        >
          <img src="https://api.baranimes.com/images/global/g-logo.png" alt="Google logo" class="w-5 h-5" />
          <span class="text-sm text-[#3c4043]">Continuer avec Google</span>
        </button>

        <div
          v-if="emailGoogle"
          class="v-input__details"
          role="alert"
          aria-live="polite"
          style="top: 30px; position: relative; color: rgb(245, 79, 103); font-size: 0.75rem; font-weight: 400"
        >
          Un compte utilise déjà cet email mais il n'est pas lié à ton compte google
        </div>
        <div class="mt-3 absolute" style="opacity: 0.01">
          <div ref="googleBtn" style="scale: 1.5; height: 100%"></div>
        </div>
      </div>
    </div>
    <div class="text-center mx-auto" style="background: none" width="100%" v-if="verify">
      <v-icon icon="mdi-arrow-left" class="absolute left-5 cursor-pointer" @click="back"></v-icon>
      <h3 class="text-h6 mb-4">Dernière étape !</h3>

      <div class="text-body-2">
        We sent a verification code to {{ registerForm.email }} <br />

        Please check your email and paste the code below.
      </div>

      <v-otp-input v-model="otp" :error="incorrect" @change="incorrect = false"></v-otp-input>
      <span style="height: 0; display: block; position: relative; top: -15px; color: #f54f67" v-if="incorrect"
        >Code incorrect - Réessayes dans 5s.</span
      >
      <v-btn class="bg-linear rounded-lg my-3" style="box-shadow: none" block @click="checkCode">Verifier</v-btn>

      <div class="text-caption">
        Didn't receive the code? <a href="#" class="underline" @click.prevent="otp = ''">Resend</a>
      </div>
    </div>
    <div class="text-center" style="background: none" width="100%" v-if="googlePseudo">
      <h3 class="text-h6 mb-4">Dernière étape, ton pseudo !</h3>

      <v-text-field
        label="Pseudo (15 caractères max)"
        v-model="registerForm.name"
        prepend-inner-icon="mdi-account"
        required
        :counter="15"
        maxlength="15"
        :rules="[v => !!v || 'Requis', !infoUsername || 'Ce pseudo est déjà utilisé']"
      />
      <v-btn class="bg-linear rounded-lg my-3" style="box-shadow: none" block @click="checkPseudo">Continuer</v-btn>
    </div>
    <div class="text-center mx-auto" style="background: none" width="100%" v-if="final">
      <h3 class="text-h6 mb-4">Ton compte a été créé avec succès !</h3>

      <v-btn class="bg-linear rounded-lg my-3" style="box-shadow: none" block @click="reload()">Continuer</v-btn>
    </div>
    <form
      @submit.prevent="sendResetMail"
      class="text-center"
      style="background: none"
      width="100%"
      v-if="passwordContainer"
    >
      <v-icon icon="mdi-arrow-left" class="absolute left-5 cursor-pointer" @click="back"></v-icon>
      <h3 class="text-h6 mb-4">Mot de passe oublié ?</h3>

      <div class="text-body-2 mb-4">Saisis l'email associé à ton compte</div>

      <v-text-field label="Email" type="email" v-model="resetEmail" prepend-inner-icon="mdi-email" required />

      <v-btn class="bg-linear rounded-lg my-3" style="box-shadow: none" block type="submit">Continuer</v-btn>
    </form>
    <div class="text-center mx-auto" style="background: none" width="100%" v-if="passwordContainerOTP">
      <v-icon icon="mdi-arrow-left" class="absolute left-5 cursor-pointer" @click="semiback"></v-icon>
      <h3 class="text-h6 mb-4">Modifier mon mot de passe</h3>

      <div class="text-body-2 mb-4">
        We sent a verification code to {{ resetEmail }}<br />

        Please check your email and paste the code below.
      </div>

      <div class="text-caption">
        Didn't receive the code? <a href="#" class="underline" @click.prevent="otp2 = ''">Resend</a>
      </div>
    </div>
    <form @submit.prevent="resetPasswordForm" class="text-center mt-4" v-if="resetPasswordEnd">
      <h3 class="text-h6 mb-4">Modifier mon mot de passe</h3>
      <v-text-field
        label="Mot de passe"
        v-model="loginForm.password2"
        :type="montrerMotDePasse3 ? 'text' : 'password'"
        :append-inner-icon="montrerMotDePasse3 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append-inner="montrerMotDePasse3 = !montrerMotDePasse3"
        prepend-inner-icon="mdi-lock"
        required
        :rules="[v => !!v || 'Requis', v => (v && v.length >= 6) || 'Minimum 6 caractères requis']"
      />
      <v-text-field
        label="Mot de passe"
        v-model="loginForm.password3"
        :type="montrerMotDePasse4 ? 'text' : 'password'"
        :append-inner-icon="montrerMotDePasse4 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append-inner="montrerMotDePasse4 = !montrerMotDePasse4"
        prepend-inner-icon="mdi-lock"
        required
        :rules="[
          v => !!v || 'Requis',
          !errorMDP || 'Les mots de passe ne sont pas identiques',
          v => (v && v.length >= 6) || 'Minimum 6 caractères requis',
        ]"
      />

      <v-btn type="submit" class="bg-linear rounded-lg" style="box-shadow: none" block>Modifier</v-btn>
    </form>
    <div class="text-center mx-auto" style="background: none" width="100%" v-if="resetPasswordEnd2">
      <h3 class="text-h6 mb-4">Ton mot de passe a bien été modifier</h3>

      <v-btn
        class="bg-linear rounded-lg my-3"
        style="box-shadow: none"
        block
        @click="
          resetPasswordEnd2 = false;
          login = true;
        "
        >Continuer</v-btn
      >
    </div>
  </v-card>
</template>

<script setup>
  import {onMounted, ref} from "vue";
  import {useFetch} from "@vueuse/core";
  import {useAuthStore} from "@/stores/auth";
  import {useGlobalStore} from "@/stores/global";

  const global = useGlobalStore();
  const auth = useAuthStore();
  const emit = defineEmits(["change-persistent"]);
  const verify = ref(false);
  const final = ref(false);
  const otp = ref(null);
  const otp2 = ref(null);
  const passwordContainer = ref(false);
  const passwordContainerOTP = ref(false);
  const googleBtn = ref(null);
  const tab = ref("register");
  const login = ref(true);
  const resetPasswordEnd = ref(false);
  const resetPasswordEnd2 = ref(false);
  const googlePseudo = ref(false);
  const montrerMotDePasse = ref(false);
  const montrerMotDePasse2 = ref(false);
  const montrerMotDePasse3 = ref(false);
  const montrerMotDePasse4 = ref(false);
  const infoUsername = ref(false);
  const infoEmail = ref(false);
  const waitRep = ref(false);
  const resetEmail = ref("");
  const incorrect = ref(false);
  const sub = ref(null);
  const errorMDP = ref(false);
  const waitTime = ref(null);
  const emailGoogle = ref(false);
  const loginForm = ref({
    email: "",
    password: "",
    password2: "",
    password3: "",
  });
  const selectedLanguage = ref(localStorage.getItem("lang"));

  const registerForm = ref({
    name: "",
    email: "",
    password: "",
  });
  const reload = () => {
    location.reload();
  };
  const back = () => {
    login.value = true;
    verify.value = false;
    passwordContainer.value = false;
    emit("change-persistent", false);
  };
  const semiback = () => {
    passwordContainer.value = true;
    passwordContainerOTP.value = false;
  };
  function resetPassword() {
    login.value = false;
    passwordContainer.value = true;
    emit("change-persistent", true);
  }
  const sendResetMail = async () => {
    if (waitRep.value) {
      return;
    }
    waitRep.value = true;
    await useFetch("https://api.baranimes.com/api/reset/password/email", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        email: resetEmail.value.trim(),
        lang: selectedLanguage.value,
      }),
    });
    passwordContainer.value = false;
    passwordContainerOTP.value = true;
    waitRep.value = false;
  };
  const handleLogin = async () => {
    const {data: response} = await useFetch("https://api.baranimes.com/api/auth/cookie", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        username: loginForm.value.email,
        password: loginForm.value.password,
      }),
    });
    if (response.value == "ok") {
      location.reload();
    } else if (response.value) {
      waitTime.value = JSON.parse(response.value);
      let tempo = loginForm.value.password;
      loginForm.value.password = loginForm.value.password + " ";
      setTimeout(function () {
        loginForm.value.password = tempo;
        setTimeout(function () {
          waitTime.value = null;
        }, 1);
      }, 1);
    } else {
      errorMDP.value = true;
      let tempo = loginForm.value.password;
      loginForm.value.password = loginForm.value.password + " ";
      setTimeout(function () {
        loginForm.value.password = tempo;
        setTimeout(function () {
          errorMDP.value = false;
        }, 1);
      }, 1);
    }
  };

  const handleRegister = async () => {
    if (registerForm.value.password < 6 || waitRep.value) {
      return;
    }
    waitRep.value = true;
    const {data: response} = await useFetch("https://api.baranimes.com/api/auth/register", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        username: registerForm.value.name.trim(),
        password: registerForm.value.password,
        email: registerForm.value.email.trim(),
        lang: selectedLanguage.value,
      }),
    });
    if (response.value == "username") {
      infoUsername.value = true;
      registerForm.value.name = registerForm.value.name + " ";
      setTimeout(function () {
        registerForm.value.name = registerForm.value.name.trim();
        setTimeout(function () {
          infoUsername.value = false;
        }, 1);
      }, 1);
    } else if (response.value == "email") {
      infoEmail.value = true;
      registerForm.value.email = registerForm.value.email + " ";
      setTimeout(function () {
        registerForm.value.email = registerForm.value.email.trim();
        setTimeout(function () {
          infoEmail.value = false;
        }, 1);
      }, 1);
    } else if (response.value == "ok") {
      login.value = false;
      verify.value = true;
      emit("change-persistent", true);
    }
    waitRep.value = false;
  };
  const checkCode = async () => {
    if (otp.value < 100000 || waitRep.value) {
      return;
    }
    waitRep.value = true;
    const {data: response} = await useFetch("https://api.baranimes.com/api/auth/otp", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        otp: otp.value,
        email: registerForm.value.email.trim(),
        username: registerForm.value.name.trim(),
        password: registerForm.value.password,
      }),
    });
    if (response.value == "ok") {
      verify.value = false;
      final.value = true;
    } else {
      otp.value = null;
      incorrect.value = true;
    }
    setTimeout(function () {
      waitRep.value = false;
    }, 5000);
  };
  const resetPasswordForm = async () => {
    if (loginForm.value.password2 != loginForm.value.password3 || waitRep.value) {
      errorMDP.value = true;
      let tempo = loginForm.value.password3;
      loginForm.value.password3 = loginForm.value.password3 + " ";
      setTimeout(function () {
        loginForm.value.password3 = tempo;
        setTimeout(function () {
          errorMDP.value = false;
        }, 1);
      }, 1);
      return;
    }
    waitRep.value = true;
    await useFetch("https://api.baranimes.com/api/auth/password/update", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        key: global.key,
        password: loginForm.value.password2,
      }),
    });
    global.key = null;
    waitRep.value = false;
    resetPasswordEnd.value = false;
    resetPasswordEnd2.value = true;
    emit("change-persistent", false);
  };

  const checkPseudo = async () => {
    if (!registerForm.value.name.trim() || waitRep.value) {
      return;
    }
    waitRep.value = true;
    const {data: response} = await useFetch("https://api.baranimes.com/api/check/pseudo", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        username: registerForm.value.name.trim(),
        sub: sub.value,
      }),
    });
    if (response.value == "ok") {
      googlePseudo.value = false;
      final.value = true;
    } else {
      infoUsername.value = true;
      registerForm.value.name = registerForm.value.name + " ";
      setTimeout(function () {
        registerForm.value.name = registerForm.value.name.trim();
        setTimeout(function () {
          infoUsername.value = false;
        }, 1);
      }, 1);
    }
    waitRep.value = false;
  };
  const handleCredentialResponse = async response => {
    const token = response.credential;
    const {data: response2} = await useFetch("https://api.baranimes.com/api/auth/google", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
      }),
    });
    if (response2.value == "ok") {
      reload();
    } else if (response2.value == "email") {
      emailGoogle.value = true;
    } else if (response2.value) {
      login.value = false;
      sub.value = response2.value.replace(/"/g, "");
      googlePseudo.value = true;
      emit("change-persistent", true);
    }
  };
  onMounted(() => {
    if (global.key) {
      login.value = false;
      resetPasswordEnd.value = true;
      emit("change-persistent", true);
    }
    window.google.accounts.id.initialize({
      client_id: "203197905550-5ud1bh7hagvdnlpeqgvc82vr0l5qduu3.apps.googleusercontent.com",
      callback: handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(googleBtn.value, {
      width: "100%",
    });
  });
</script>
